// removed by extract-text-webpack-plugin
module.exports = {"Icon":"_2g0xWqmvwfzOx3YNiAlFQi","SortHelpText":"_2-4UTCW-mX30B70ivJL6-d","QuestionsList":"_3IhoFO7MnqvpYe851VnUiO","NoPostsText":"_3gpYb_4nwoCJYhpaIhSCBT","QuestionsListWrapper":"_3q5L43RV0pWbYmeTtBuJya"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Questions/style.css
// module id = 2044
// module chunks = 0